// extracted by mini-css-extract-plugin
export default {"container":"about_container__MSSm8"};